import { WebApi } from '.'

import {
  AnnouncementDetailResponse,
  AnnouncementNoticeResponse,
  AnnouncementsParams,
  AnnouncementsResponse,
  EAnnouncementType,
} from '~/features/announcements/types'

export const NewsApi = WebApi.injectEndpoints({
  endpoints: (build) => ({
    getLive: build.query<AnnouncementsResponse, AnnouncementsParams>({
      query: (params) => ({
        url: '/news/getlive',
        params: {
          tag_id: params.tag_id,
          page_size: params.page_size,
          page: params.page,
        },
        credentials: 'include',
      }),
    }),
    getLivePost: build.query<AnnouncementDetailResponse, { id: number }>({
      query: (params) => ({
        url: '/news/getlivepost',
        params: {
          id: params.id,
        },
        credentials: 'include',
      }),
    }),
    getNotice: build.query<AnnouncementNoticeResponse, { tag_id?: EAnnouncementType; tag_ids?: EAnnouncementType[] }>({
      query: (params) => ({
        url: '/news/notice',
        params: {
          tag_id: params.tag_id,
          tag_ids: params.tag_ids?.join(','),
        },
        credentials: 'include',
      }),
    }),
  }),
}).endpoints
